<template>
    <main class="bg-white">
        <div class="relative flex">
            <div class="w-full md:w-1/2 pt-4">
                <div class="min-h-screen h-full flex flex-col after:flex-1">
                    <div class="flex-1">
                        <div class="flex items-center  sm:justify-between justify-center h-16 px-4 sm:px-6 lg:px-8">
                            <a href="/">
                                <img style="height:75px !important" :src="logo" />
                            </a>
                            <slot name="headerRight" />
                        </div>
                        <slot name="headerBottom" />
                    </div>
                    <div :class="'max-w-' + width + ' mx-auto px-4 py-8'">
                        <h1 v-if="title" class="text-3xl text-gray-800 font-bold mb-6">{{ title }} ✨</h1>

                        <slot />
                    </div>
                </div>
            </div>

            <div class="hidden md:block absolute top-0 bottom-0 right-0 md:w-1/2" aria-hidden="true">
                <img class="object-cover object-center w-full h-full"
                    :src="background" width="760" height="1024"
                />
                <img class="absolute top-1/4 left-0 transform -translate-x-1/2 ml-8 hidden lg:block"
                    src="/images/auth-decoration.png" width="218" height="224"
                />
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        props: {
            background: {
                type: String,
                default: '/images/auth-image.jpg'
            },

            logo: {
                type: String,
                default: '/assets/img/logo.png'
            },

            width: {
                type: String,
                default: 'sm'
            },

            title: {
                type: String,
                default: null
            },
        }
    }
</script>
